import { format, isValid } from "date-fns";

export const dateFormatForREST = (
  date: string | Date,
  formatFor?: "Andrey",
) => {
  switch (formatFor) {
    case "Andrey": {
      const parsed = new Date(date);
      return isValid(parsed) ? format(parsed, "yyyy-MM-dd") : "Invalid date";
    }
    default:
      return new Date(date).toISOString();
  }
};
